define([
  'modules/projects/models/projectbase',
  'appcontext',
  'store'
], (BaseModel, appContext, store) => {
  store = store.default;

  return BaseModel.extend({
    urlRoot: '/projects',

    defaults() {
      const defaults = {
        id: null,
        account_id: null,
        brand_id: null,
        name: null,
        start_date: null,
        end_date: null,
        status: 'ACTIVE',
        budget_scope: 'ORDER_PERIOD',
        manage_placements: Boolean(store.getters['common/defaultParams'].project.manage_placements),
        check_url_errors: false,
        check_url_stop_ads_on_errors: false,
        check_url_redirects: false,
        fin_brand_name: null,
        fin_project_name: null,
        has_active_periods: false,
        default_tagging_group_templates_enabled: {
          1: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
          8: false
        }
      };

      if (appContext.account() && appContext.has_component('RORE')) {

        // rore would like managing placements being disabled for new projects by default
        defaults.manage_placements = false;
      }

      return defaults;
    },

    isArchived() {
      return this.get('status') === 'ARCHIVED';
    },
    isFineTuned() {
      return this.get('is_fine_tuned');
    },

    destroy() {
      return BaseModel.prototype.destroy.apply(this, arguments);
    }
  });
});
